import React, { useRef, useState , useEffect,useMemo} from 'react';
import moment from 'moment';
import {
  StructuredGenerate,
  DynamicDropDownInput,
  DynamicNumericInput,
  DynamicDateInput,
  DynamicTextInput,
  DynamicCheckBoxInput,
  DynamicHiddenInput,
  DynamicButtonInput,
  DynamicCellInput,
  DynamicEmailInput
} from '../software-dynamic-version-2/mainSection-multiple-inputs-v-2';
import DropdownService from '../software-dynamic-version-3/api.service-v-3';
import DynamicInputGrid from '../software-dynamic-version-3/popup-input-grid-v-3';
import { Tabs, Tab, Box, Typography } from '@mui/material';
import AddNewDialog from '../software-dynamic-version-2/addNew-popup-list-v-2';
import ListButtonPopupList from '../software-dynamic-version-2/list-button-popup-list-v-2';

import {
  TabComponent,
  TabItemDirective,
  TabItemsDirective,
} from '@syncfusion/ej2-react-navigations';
import tenantContractService from './tenant-contract.service';
import securityService from '../security/security.service';

const TenantContractAdd = (props) => {
  
  let { DynamicDropDownInput: DropdownComponent, DynamicNumericInput: NumberComponent, DynamicDateInput: DateComponent , DynamicTextInput: TextComponent ,DynamicCheckBoxInput:CheckBoxComponent , DynamicHiddenInput : HiddenComponent , DynamicButtonInput:ButtonComponent,DynamicCellInput:PhoneComponent,DynamicEmailInput:EmailComponent} = { DynamicDropDownInput, DynamicNumericInput, DynamicDateInput ,DynamicTextInput , DynamicCheckBoxInput,DynamicHiddenInput,DynamicButtonInput,DynamicCellInput,DynamicEmailInput};
  
  // updateMainSecionsValue( {
  //   CustomerName:{value: response.data.recordset[0]?.AName || '',},
  //   ExportOrderDate:{value: response.data.recordset[0]?.ExportOrderDate || props.ExportOrderDate,},
  //   ShipmentDate:{value: response.data.recordset[0]?.ShipmentDate || props.ShipmentDate,},
  //   OrderQuantity:{value: response.data.recordset[0]?.TotalTowelQuantity || 0}
  // });
  
  const updateMainSecionsValue = (valueObj) => {
    setInputProps((prevValues) => {
      const updatedValues = { ...prevValues };
  
      Object.keys(valueObj).forEach((key) => {
        if (updatedValues[key]) {
          updatedValues[key] = {
            ...updatedValues[key],
            ...valueObj[key], // Spread the inner object to update its properties
          };
        }
      });
  
      return updatedValues;
    });
  };
  
const [inputProps, setInputProps] = useState({
  CallGridDataSource: { name: 'CallGridDataSource', value: props.isAdd == false },
  SelectRowByID: { name: 'SelectRowByID', value: undefined },
  
  ThirdGridDataSource : {name:'ThirdGridDataSource', value:[]},
  CallThirdGridDataSource : {name:'CallThirdGridDataSource', value:false},

  TenantContractFSID: { name: 'TenantContractFSID', value: props.TenantContractFSID || undefined  },

  CompanyID: { name: 'CompanyID', value: props.CompanyID || securityService.getCompanyIDLoggedInUserId() },
 
  TenantContractFSDate: { name: 'TenantContractFSDate',caption:'Contract Date', value: props.TenantContractFSDate || 'currentDate' },
  CompanyRepresentedBy: { name: 'CompanyRepresentedBy',caption:'Represented By', value: props.CompanyRepresentedBy || '' },

  AccountTitle: {
    name: { id: 'AccountID', value: 'AccountTitle' },
    caption: 'Select Tenant Name',
    value: { id: props.AccountID || 'undefined', value: props.AccountTitle || '' },
    dataSource: { type: 'Route', route: 'TenantContractAccount' },
    addNew: { Route: 'ReceivableAccounts', Security: 'Receivable Accounts' },
},
TenantTradeLicenseNo: { name: 'TenantTradeLicenseNo', caption:'Trade License No./ Initial' , value: props.TenantTradeLicenseNo || '-' },
TenantRepresentedBy: { name: 'TenantRepresentedBy', caption:'Represented By' , value: props.TenantRepresentedBy || '-' },
TenantPassportEIDNo: { name: 'TenantPassportEIDNo',caption:'Passport / EID No.' , value: props.TenantPassportEIDNo || '-' },


Nationality: {
    name: { id: 'NationalityID' ,  value: 'Nationality' },
    caption: 'Select Nationality',
    value: { id: props.NationalityID || 'undefined', value: props.Nationality || '' },
    dataSource: { type: 'Route', route: 'Nationality' },
    addNew: { Route: 'Nationality', Security: 'Nationality' },
},

TenantEmail: { name: 'TenantEmail',  caption:'Tenant Email' ,value: props.TenantEmail || '' },
TenantCellNo: { name: 'TenantCellNo', caption:'Mobile No.' ,value: props.TenantCellNo || ''  },

ContractStartDate: { name: 'ContractStartDate',caption:'From Date', value: props.ContractStartDate || '' },
ContractEndDate: { name: 'ContractEndDate',caption:'To Date', value: props.ContractEndDate || '', min:'' },
DifferentDaysOfStartAndEndDates : {name: 'DifferentDaysOfStartAndEndDates',value:0},

RentAmountAED: { name: 'RentAmountAED',caption:'Rent Amount', value: props.RentAmountAED || 0 ,decimal:2 },
DiscountAmountAED: { name: 'DiscountAmountAED',caption:'Discount Amount', value: props.DiscountAmountAED || 0 ,decimal:2 },
NetAmount: { name: 'NetAmount',caption:'Net Rent Amount' ,  value: props.NetRentAmount || 0 ,decimal:2 ,enabled: false},
ContractAmountAED: { name: 'ContractAmountAED', caption:'Contract Amount',value: props.ContractAmountAED || 0,decimal:2  ,enabled:false  },
AccountTitleAgent: {
  name: { id: 'AccountIDAgent', value: 'AccountTitleAgent' },
  caption: 'Select Agent Name',
  value: { id: props.AccountIDAgent || 'undefined', value: props.AccountTitleAgent || '' },
  dataSource: { type: 'Route', route: 'AccountAgentTenantContractFS' },
  addNew: { Route: 'AgentAccounts', Security: 'Agent Accounts' },

},
TotalContractAmountAED: { name: 'TotalContractAmountAED',caption:'Total Contract Amount', value: props.TotalContractAmountAED || 0, decimal:2 , enabled:false },
AgentCommissionPercent: { name: 'AgentCommissionPercent',caption:'Agent Commission  %', value: props.AgentCommissionPercent || 0 ,decimal:2 },
AgentCommissionAmount: { name: 'AgentCommissionAmount',caption:'Agent Commission Amount', value: props.AgentCommissionAmount || 0 ,decimal:2, enabled:false },


});
// EXTRA CODE START
useEffect(()=>{

  if(props.isAdd == false ){
    generateNetRentAmount()
    updateMainSecionsValue( {ContractEndDate:{min: new Date(props.ContractStartDate) || ''}});
    // generateContractAmount(props.ContractStartDate,props.ContractEndDate)
    setTimeout(()=>
      generateDatesDiff(props.ContractStartDate,props.ContractEndDate)
    .then(diff => {
      console.log(`Difference in days: ${diff}`);
      updateMainSecionsValue({ DifferentDaysOfStartAndEndDates: { value: diff } });
      setTimeout(() => {
        // generateContractAmount(props.ContractStartDate,props.ContractEndDate)
      }, 1000);
  })
  .catch(error => {
      console.error(error.message);
      updateMainSecionsValue({ DifferentDaysOfStartAndEndDates: { value: 0 } });
      setTimeout(() => {
        // generateContractAmount(0,inputProps.NetAmount.value)
      }, 1000);
  })
    ,150) 



    // setTimeout(() => {
    //   getAgentCommissionAmount()
    // }, 2000);
  }
},[])


const generateNetRentAmount = async ()=>{
  setTimeout(() => {
    console.log(inputProps.DiscountAmountAED.value ,inputProps.RentAmountAED.value);

    let value = inputProps.RentAmountAED.value - inputProps.DiscountAmountAED.value  ;
    console.log(value)
    updateMainSecionsValue({ NetAmount : {value : value} })
  },555);
}
// const generateContractAmount = async (days,netRentAmount)=>{
//   console.log(days,netRentAmount)
//   console.log(inputProps)
//   let contractDays = Math.round(days / 30)
//   let netValue = parseInt(inputProps.RentAmountAED.value) -  parseInt(inputProps.DiscountAmountAED.value)

//   let contractAmount = (netValue / 12) * contractDays
//   console.log(contractAmount)
//   // updateMainSecionsValue({ ContractAmountAED : {value : contractAmount} })
//    setInputProps((prevValues) => ({
//               ...prevValues,
//               ['ContractAmountAED']: {...prevValues['ContractAmountAED'] ,value : contractAmount}
//             }));
//   updateThirdGridData(contractAmount)
// }

const generateContractAmount = async (startDate, endDate) => {
  if (!startDate || !endDate) return;

  try {
    const response = await tenantContractService.getTenantContractFSAmount(
      inputProps.RentAmountAED.value,
      inputProps.DiscountAmountAED.value,
      startDate,
      endDate
    );

    if (response?.data) {
      const contractAmount = response.data.recordset[0].ContractAmount;
      console.log(`Contract Amount: ${contractAmount}`);
      setInputProps((prevValues) => ({
        ...prevValues,
        ['ContractAmountAED']: { ...prevValues['ContractAmountAED'], value: contractAmount }
      }));
      updateThirdGridData(contractAmount);
    }
  } catch (error) {
    console.error("Error fetching contract amount:", error);
    setInputProps((prevValues) => ({
      ...prevValues,
      ['ContractAmountAED']: { ...prevValues['ContractAmountAED'], value: 0 }
    }));
    updateThirdGridData(0);
  }
};
const updateTotalTenantContractFSAmount = async ( gridData) =>  {
if(gridData.length > 0){
  
  console.log(gridData.length);
  const contractAmount = Math.round(document.getElementById('ContractAmountAED_display').value.replace(/,/g, ''));

  let DEPOSIT =  gridData.filter((e)=>e.AccountID == 229)
  console.log(DEPOSIT);
  const sumAdditionalPaymentAmount = gridData.reduce((sum, row) => sum + (row.AdditionalPaymentAmount || 0), 0);

  console.log(sumAdditionalPaymentAmount);
  let response = await tenantContractService.getTotalTenantContractFSAmount(contractAmount,DEPOSIT[0]?.AdditionalPaymentAmount || 0,sumAdditionalPaymentAmount )
  console.log(response)
  updateMainSecionsValue({
    TotalContractAmountAED:{value:parseFloat(response.data.recordset[0].TotalContractAmountAED).toFixed(2)}
  })
}
}

const updateThirdGridData = async (contractAmount)=>{
  console.log(contractAmount)
  if(inputProps.TenantContractFSID.value){
    let response = await tenantContractService.updateTenantContractFSAdditionalPaymentPercentBasedCalculations(contractAmount,inputProps.TenantContractFSID.value);
    if(response.data){
      await callThirdGridDataSources(inputProps.TenantContractFSID.value)
      setTimeout(() => {
        updateTotalTenantContractFSAmount( inputProps.ThirdGridDataSource.value)
        
      }, 1000);

    }
  }else {
    console.log(inputProps.ThirdGridDataSource.value);
         updateMainSecionsValue({ CallThirdGridDataSource : {value :  true} })

   let updateAddtionalPaymentAmounts = inputProps.ThirdGridDataSource.value.map((e)=>{
      console.log(e.AdditionalPaymentPercent)
      let AdditionalAmount = contractAmount * (e.AdditionalPaymentPercent / 100)
      console.log(AdditionalAmount)
      return{
        ...e,
        AdditionalPaymentAmount:AdditionalAmount
      }
    })
    console.log(updateAddtionalPaymentAmounts)
    updateMainSecionsValue({ThirdGridDataSource: {value:updateAddtionalPaymentAmounts}})
     updateMainSecionsValue({ CallThirdGridDataSource : {value :  false} })
     updateTotalTenantContractFSAmount( updateAddtionalPaymentAmounts)
  } 
  
}



const getAgentCommissionAmount = async (gridData , id) =>{
  console.log(gridData);
  console.log(inputProps.AgentCommissionPercent.value);
  let agentCommissionPercent = Math.round(document.getElementById('AgentCommissionPercent_display').value.replace(/,/g, ''));
  if(id){
    let response = await tenantContractService.getPaymentDetailForList(id)
    console.log(response);
    // const sumChequeAmount = response.data.recordset.reduce((sum, row) => sum + (row.ChequeAmount || 0), 0);
    let  rentAmount = Math.round(document.getElementById('RentAmountAED').value.replace(/,/g, '')) ;
    let  discountAmount = Math.round(document.getElementById('DiscountAmountAED').value.replace(/,/g, '')) ;


    let sumChequeAmount = rentAmount - discountAmount;


console.log(sumChequeAmount);
const sumAdditionalPaymentAmount = gridData.reduce((sum, row) => sum + (row.AdditionalPaymentAmount || 0), 0);

console.log(sumAdditionalPaymentAmount);
    let AgentCommissionAmount =  await tenantContractService.getAgentCommissionAmount(sumChequeAmount,sumAdditionalPaymentAmount  , agentCommissionPercent);
    console.log(AgentCommissionAmount)
    
    updateMainSecionsValue({
      AgentCommissionAmount:{value:AgentCommissionAmount.data.recordset[0].AgentCommissionAmountAED}
    })

  }else{
    const sumAdditionalPaymentAmount = gridData.reduce((sum, row) => sum + (row.AdditionalPaymentAmount || 0), 0);

console.log(sumAdditionalPaymentAmount);
// const sumChequeAmount = Math.round(document.getElementById('RentAmountAED').value.replace(/,/g, '')) ;
let  rentAmount = Math.round(document.getElementById('RentAmountAED').value.replace(/,/g, '')) ;
    let  discountAmount = Math.round(document.getElementById('DiscountAmountAED').value.replace(/,/g, '')) ;


    let sumChequeAmount = rentAmount - discountAmount;

    let AgentCommissionAmount =  await tenantContractService.getAgentCommissionAmount(sumChequeAmount,sumAdditionalPaymentAmount , agentCommissionPercent);
    console.log(AgentCommissionAmount)
    updateMainSecionsValue({
      AgentCommissionAmount:{value:AgentCommissionAmount.data.recordset[0].AgentCommissionAmountAED}
    })
  }



}

const generateDatesDiff = async (startDate, endDate) => {
  // Convert both dates to Date objects
  const start = new Date(startDate);
  const end = new Date(endDate);

  // Check if the dates are valid
  if (isNaN(start) || isNaN(end)) {
      throw new Error("Invalid date format");
  }

  // Calculate the difference in milliseconds
  const diffInMs = end - start;

  // Convert the difference from milliseconds to days
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

  return diffInDays;
};





// EXTRA CODE END

const handleInputCreated = async (e, name) => {
  console.log(e);
   if(name == 'CompanyRepresentedBy' && props.isAdd == true){
      const response = await DropdownService.getAllForList('TenantContractRepresentedBy');
          if (response.data || response.data.recordset) {
        updateMainSecionsValue( {CompanyRepresentedBy:{value: response.data.recordset[0]?.RepresentedBy || '',}});
          }
          
        }
    console.log(`Input ${name} changed to ${e}`);
  };
const handleInputFocus = async (e, name) => {
  
    console.log(e);
    console.log(`Input ${name} focus to ${e}`);
  };
const handleInputChange = async (value, name) => {
    if(name == 'ContractStartDate'){
      updateMainSecionsValue( {ContractEndDate:{min: new Date(value) || ''}});
      generateContractAmount(value,inputProps.ContractEndDate.value)
      setTimeout(()=>
        generateDatesDiff(value,inputProps.ContractEndDate.value)
      .then(diff => {
        console.log(`Difference in days: ${diff}`);
        updateMainSecionsValue({ DifferentDaysOfStartAndEndDates: { value: diff } });
        // generateContractAmount(diff,inputProps.NetAmount.value)
    })
    .catch(error => {
        console.error(error.message);
        updateMainSecionsValue({ DifferentDaysOfStartAndEndDates: { value: 0 } });
        // generateContractAmount(0,inputProps.NetAmount.value)
        // generateContractAmount(0,inputProps.NetAmount.value)
    })
      ,150) 
  }else
    if( name == 'ContractEndDate'){
      setTimeout(() => {
        generateContractAmount(inputProps.ContractStartDate.value, value)
        generateDatesDiff(inputProps.ContractStartDate.value, value)
            .then(diff => {
                console.log(`Difference in days: ${diff}`);
                updateMainSecionsValue({ DifferentDaysOfStartAndEndDates: { value: diff } });
                // generateContractAmount(diff,inputProps.NetAmount.value)
            })
            .catch(error => {
                console.error(error.message);
                updateMainSecionsValue({ DifferentDaysOfStartAndEndDates: { value: 0 } });
                // generateContractAmount(0,inputProps.NetAmount.value)
            });
    }, 150);
    
    
    }
    console.log(value);
    console.log(`Input ${name} focus to ${value}`);
  };
const handleInputBlur = async  (value, name) => {
  if(name == 'DiscountAmountAED' || name == 'RentAmountAED'){
    generateNetRentAmount()
    setTimeout(() => {
      generateContractAmount(inputProps.ContractStartDate.value, inputProps.ContractEndDate.value)

    }, 560);
  }
   if(name == 'AgentCommissionPercent' || name == 'RentAmountAED' || name == 'DiscountAmountAED'){
    setTimeout(() => {
      
      getAgentCommissionAmount(inputProps.ThirdGridDataSource.value , inputProps.TenantContractFSID.value);
    }, 1000);
    setTimeout(() => {
      
      document.getElementById('TenantContractGrid_dialogEdit_wrapper_dialog-content')
      .scrollTo({
        top: document.body.scrollHeight,
        behavior: 'smooth'
      });
    }, 500);
  
  }
  if(name == 'ContractStartDate'){
    // updateMainSecionsValue( {ContractEndDate:{min: new Date(value) || ''}});
    generateContractAmount(value,inputProps.ContractEndDate.value)
    setTimeout(()=>
      generateDatesDiff(value,inputProps.ContractEndDate.value)
    .then(diff => {
      console.log(`Difference in days: ${diff}`);
      updateMainSecionsValue({ DifferentDaysOfStartAndEndDates: { value: diff } });
      // generateContractAmount(diff,inputProps.NetAmount.value)
  })
  .catch(error => {
      console.error(error.message);
      updateMainSecionsValue({ DifferentDaysOfStartAndEndDates: { value: 0 } });
      // generateContractAmount(0,inputProps.NetAmount.value)
  })
    ,150) 
}else
  if( name == 'ContractEndDate'){
    setTimeout(() => {
      generateContractAmount(inputProps.ContractStartDate.value, value)
      generateDatesDiff(inputProps.ContractStartDate.value, value)
          .then(diff => {
              console.log(`Difference in days: ${diff}`);
              updateMainSecionsValue({ DifferentDaysOfStartAndEndDates: { value: diff } });
              // generateContractAmount(diff,inputProps.NetAmount.value)
          })
          .catch(error => {
              console.error(error.message);
              updateMainSecionsValue({ DifferentDaysOfStartAndEndDates: { value: 0 } });
              // generateContractAmount(0,inputProps.NetAmount.value)
          });
  }, 150);
  
  
  }
    console.log(value);
    console.log(`Input ${name} focus to ${value}`);
  };
 
  let inputsList = [

{ Input: HiddenComponent, Props: { ...inputProps.CompanyID, setInputProps }, ColumnSize: 0 },
{ Input: HiddenComponent, Props: { ...inputProps.TenantContractFSID, setInputProps }, ColumnSize: 0 },
{ Input: DateComponent, Props: { ...inputProps.TenantContractFSDate, setInputProps }, ColumnSize: 4 },
{ Input: TextComponent, Props: { ...inputProps.CompanyRepresentedBy, setInputProps ,onCreated:handleInputCreated }, ColumnSize: 4 },
{ Input: DropdownComponent, Props: { ...inputProps.AccountTitle, setInputProps }, ColumnSize: 4 },
{ Input: TextComponent, Props: { ...inputProps.TenantTradeLicenseNo, setInputProps }, ColumnSize: 4 },
{ Input: TextComponent, Props: { ...inputProps.TenantRepresentedBy, setInputProps }, ColumnSize: 4 },
{ Input: TextComponent, Props: { ...inputProps.TenantPassportEIDNo, setInputProps }, ColumnSize: 4 },
{ Input: DropdownComponent, Props: { ...inputProps.Nationality, setInputProps }, ColumnSize: 4 },

{ Input: EmailComponent, Props: { ...inputProps.TenantEmail, setInputProps }, ColumnSize: 4 },
{ Input: PhoneComponent, Props: { ...inputProps.TenantCellNo, setInputProps }, ColumnSize: 4 },
{ Input: DateComponent, Props: { ...inputProps.ContractStartDate, setInputProps  ,onCreated:handleInputCreated,onChange:handleInputChange,onBlur:handleInputBlur }, ColumnSize: 4 },
{ Input: DateComponent, Props: { ...inputProps.ContractEndDate, setInputProps  ,onCreated:handleInputCreated,onChange:handleInputChange ,onBlur:handleInputBlur}, ColumnSize: 4 },
{ Input: HiddenComponent, Props: { name:'space1', setInputProps }, ColumnSize: 4 },
{ Input: NumberComponent, Props: { ...inputProps.RentAmountAED, setInputProps ,onChange:handleInputChange ,onBlur:handleInputBlur}, ColumnSize: 4 },
{ Input: NumberComponent, Props: { ...inputProps.DiscountAmountAED, setInputProps  ,onChange:handleInputChange , onBlur:handleInputBlur}, ColumnSize: 4 },
{ Input: NumberComponent, Props: { ...inputProps.NetAmount, setInputProps }, ColumnSize: 4 },
{ Input: NumberComponent, Props: { ...inputProps.ContractAmountAED, setInputProps }, ColumnSize: 4 },
{ Input: NumberComponent, Props: { ...inputProps.TotalContractAmountAED, setInputProps }, ColumnSize: 4 },
{ Input: HiddenComponent, Props: { name:'space2', setInputProps }, ColumnSize: 4 },
{ Input: DropdownComponent, Props: { ...inputProps.AccountTitleAgent, setInputProps }, ColumnSize: 4 },
{ Input: NumberComponent, Props: { ...inputProps.AgentCommissionPercent, setInputProps ,onBlur:handleInputBlur}, ColumnSize: 4 },
{ Input: NumberComponent, Props: { ...inputProps.AgentCommissionAmount, setInputProps }, ColumnSize: 4 },
];


/// DETAIL SECIION START *************************************************************
// ***********************************************************************
// ***********************************************************************
// ***********************************************************************
// ***********************************************************************

const SaveButton = (GridID = props.GridID ,visibility)=>{
  document.querySelector(`#${GridID}Grid_dialogEdit_wrapper > .e-footer-content button.e-control.e-btn.e-lib.e-primary.e-flat`).style.visibility = `${visibility}`;
}
let CallGridDataSources = ()=>{
  setInputProps((prevValues) => ({
    ...prevValues,
    ['CallGridDataSource']: {...prevValues['CallGridDataSource'] ,value :true}
  }));
  setTimeout(() => {
    
    setInputProps((prevValues) => ({
      ...prevValues,
      ['CallGridDataSource']: {...prevValues['CallGridDataSource'] ,value :false}
    }));
  }, 300);
}
useEffect(()=>{
  CallGridDataSources()
  callThirdGridDataSources(props.TenantContractFSID)

},[])
const callThirdGridDataSources = async (id)=>{
  try {
    updateMainSecionsValue({ CallThirdGridDataSource : {value :  true} })
    let response =  id ? await tenantContractService.getAdditionalPaymentDetailForList(id || inputProps.TenantContractFSID.value) : await tenantContractService.spGetAddionalPayment();
    console.log(response)
    updateMainSecionsValue({ ThirdGridDataSource : {value :  response.data.recordset} })
    updateMainSecionsValue({ CallThirdGridDataSource : {value :  false} })
    updateTotalTenantContractFSAmount(response.data.recordset)
    getAgentCommissionAmount(response.data.recordset ,inputProps.TenantContractFSID.value)
    if(props.isAdd == false){
    }

  } catch (error) {
    
  }
}
// TenantContractFSID	
// FullPropertyID
// FullPropertyName
// TenantContractFSPropertyDetailID
let propertyDetailColumns = [
  { field:"TenantContractFSID",headerText:'ID',width:'90px',textAlign:'left' ,headerTextAlign:'center',other:[{visible:false}]},

  { field:"FullPropertyID",headerText:'Full Property ID' ,width:'140px',textAlign:'left' ,headerTextAlign:'center',other:[{visible:false}]},
  { field:"FullPropertyName",headerText:'Full Property Name',width:'140px',textAlign:'left' ,headerTextAlign:'center',other:[{endEdit:true,'editType':'dropdownedit',edit:{
    caption:'Full Property Name' ,source:{type:"Route",dataSource:'PropertyDetailFullPropertyName'} , field:{id:'FullPropertyID',value:'FullPropertyName'}, filter:{},
    // select:{source:{type:'Function',dataSource:{function:invoiceService.getMultiDropDownSource , params :[{type:'Value',source:'Stock'},{type:'Value',source:'0'},{type:'Value',source:'01-JUN-24'},{type:'Value',source:moment().format('DD-MMM-YY')},{type:'Column',source:'BrandID'}] , dropDownKey:'ProductID'}}},
  }
  }]},
  { field:"TenantContractFSPropertyDetailID",headerText:'TenantContractFSPropertyDetailID',width:'180px',textAlign:'left' ,headerTextAlign:'center',other:[{visible:false}]},

]


const propertyDetailActionComplete = async (
  
   grid,
    args,
    setDataSourceState,
    getListService,
    selectedRow,
    selectRowByID,
    startEdit,
    addUserLog,
    editUserLog,
    dataSourceStateLength
)=>{
    
  console.log(selectedRow)
  console.log(args)
  console.log(grid)
  if(args.requestType == 'add' || args.requestType == 'beginEdit'){
    // setTimeout(()=>{SaveButton(props.GridID ,'hidden')},1000)
      setTimeout(()=>{SaveButton(props.GridID ,'hidden')},1000)
      
  }
  if(args.requestType === 'save' || args.requestType =='cancel'){
    setTimeout(()=>{SaveButton(props.GridID ,'visible')},1000)

  }
  if(args.requestType == 'save'){
    let PropertyDetailData = {}
    setInputProps((prevValues) => {
      console.log(prevValues);
      PropertyDetailData = prevValues
      return {...prevValues
     }});
     console.log(PropertyDetailData)
     let data={
      TenantContractFSID:PropertyDetailData.TenantContractFSID.value,
      CompanyID: PropertyDetailData.CompanyID.value,
      TenantContractFSDate: PropertyDetailData.TenantContractFSDate.value,
      CompanyRepresentedBy:	 PropertyDetailData.CompanyRepresentedBy.value,
      AccountID	: PropertyDetailData.AccountTitle.value.id,
      TenantTradeLicenseNo	: PropertyDetailData.TenantTradeLicenseNo.value,
      TenantRepresentedBy	: PropertyDetailData.TenantRepresentedBy.value,
      TenantPassportEIDNo: PropertyDetailData.TenantPassportEIDNo.value,
      NationalityID: PropertyDetailData.Nationality.value.id,
      TenantEmail: PropertyDetailData.TenantEmail.value,
      TenantCellNo: PropertyDetailData.TenantCellNo.value,
      ContractStartDate: PropertyDetailData.ContractStartDate.value,
      ContractEndDate: PropertyDetailData.ContractEndDate.value,
      RentAmountAED: PropertyDetailData.RentAmountAED.value,
      DiscountAmountAED: PropertyDetailData.DiscountAmountAED.value,
      AccountIDAgent: PropertyDetailData.AccountTitleAgent.value.id,
      AgentCommissionAmount: PropertyDetailData.AgentCommissionAmount.value,
      AgentCommissionPercent: PropertyDetailData.AgentCommissionPercent.value,


      // Attachment1Path: PropertyDetailData.Attachment1Path.value,
      // Attachment2Path: PropertyDetailData.Attachment2Path.value,
      // Attachment3Path: PropertyDetailData.Attachment3Path.value,
      // Attachment4Path: PropertyDetailData.Attachment4Path.value,
      // Attachment5Path: PropertyDetailData.Attachment5Path.value,
      
      ContractAmountAED: PropertyDetailData.ContractAmountAED.value,
      TotalContractAmountAED: PropertyDetailData.TotalContractAmountAED.value,
      
      FullPropertyID:args.data.FullPropertyID,
      FullPropertyName:args.data.FullPropertyName,
      TenantContractFSPropertyDetailID:args.data.TenantContractFSPropertyDetailID,
      params:{
        TenantContractFSID:PropertyDetailData.TenantContractFSID.value,
        },
        details:[
          ...PropertyDetailData.ThirdGridDataSource.value
        ]
    }

   if(args.action == 'add'){
  
     const response = data.TenantContractFSID == undefined ? await tenantContractService.insertPropertyDetailWithMain(data) : await tenantContractService.insertPropertyDetail(data);
             console.log(response.data)
               updateMainSecionsValue( {
                TenantContractFSID:{value:response.data.TenantContractFSID}
               })
            CallGridDataSources()
            callThirdGridDataSources(response.data.TenantContractFSID)

   
             setTimeout(()=>document.getElementById('TenantContractFS_PropertyDetailGrid_add').click(),1800)
             setTimeout(() => {
              if(document.getElementById('TenantContractGrid_dialogEdit_wrapper_dialog')){
               document.getElementById('TenantContractGrid_dialogEdit_wrapper_dialog').scrollTo({
                top: '100px',
                behavior: "smooth"  // Optional: adds smooth scrolling
              });
            }
              // // .scrollTo({
              //   bottom: 15,
              //   behavior: "smooth"  // Optional: adds smooth scrolling
              // });
             }, 2200)
   }
   if(args.action == 'edit'){
    if(data.TenantContractFSPropertyDetailID){
     const response = await tenantContractService.updatePropertyDetail(data);
             console.log(response)
            //  await setDataSourceState(response.data.Recordsets.recordset)
            CallGridDataSources()
            setTimeout(() => {
              const element = document.getElementById('TenantContractGrid_dialogEdit_wrapper_dialog_dialog-content');
              if (element) {
                  element.scrollTo({
                      top: 100,
                      behavior: "smooth"  // Optional: adds smooth scrolling
                  });
              }
          }, 1500);
          var gridLength =grid.currentViewData.length
          setTimeout(() => {
              
            let  rowsInd = args.rowIndex +1;

          if(rowsInd < gridLength){
              
            //(args)
            selectRowByID(rowsInd)
            startEdit() 

          }else{
            setTimeout(()=>document.getElementById('TenantContractFS_PropertyDetailGrid_add').click(),100)

            if(props.isAdd){
              // productsDetailGrid.refresh()
            }
          }
           
           }, 1000);
          //  getListService(true)
    }else{
      //  getListService(true)
     CallGridDataSources()
    }
   }
     console.log(data)
   
       console.log(inputProps)
     
  
  }

}

///TenantContractFSID	ModeOfPaymentID	ChequeNo	ChequeDate	ChequeAmount	IsChequeCleared	TenantContractFSPaymentDetailID

let paymentDetailColumns = [
  { field:"TenantContractFSID",headerText:'ID',width:'90px',textAlign:'left' ,headerTextAlign:'center',other:[{visible:false}]},

  { field:"ModeOfPaymentID",headerText:'Mode Of Payment ID' ,width:'140px',textAlign:'left' ,headerTextAlign:'center',other:[{visible:false}]},
  { field:"ModeOfPayment",headerText:'Mode Of Payment',width:'140px',textAlign:'left' ,headerTextAlign:'center',other:[{'editType':'dropdownedit',edit:{
    caption:'Mode Of Payment' ,source:{type:"Route",dataSource:'PaymentDetailModeOfPayment'} , field:{id:'ModeOfPaymentID',value:'ModeOfPayment'}, filter:{},
    // select:{source:{type:'Function',dataSource:{function:invoiceService.getMultiDropDownSource , params :[{type:'Value',source:'Stock'},{type:'Value',source:'0'},{type:'Value',source:'01-JUN-24'},{type:'Value',source:moment().format('DD-MMM-YY')},{type:'Column',source:'BrandID'}] , dropDownKey:'ProductID'}}},
  }
  }]},
  { field:"ChequeNo",headerText:'Cheque No',width:'150px',textAlign:'left' ,headerTextAlign:'center',other:[{}]},
  { field:"ChequeDate",headerText:'Cheque Date',width:'145px',textAlign:'left' ,headerTextAlign:'center',other:[{editType:'datepickeredit'}]},
  { field:"ChequeAmount",headerText:' Amount',width:'135px',textAlign:'right' ,headerTextAlign:'center',other:[{initialValue:0,format:'n2',edit:{format:'n2'},editType:'numericedit'}]},
  { field:"ChequeCleared",headerText:'Is Cheque Cleared',width:'140px',textAlign:'left' ,headerTextAlign:'center',other:[{'editType':'dropdownedit',endEdit:true,edit:{
    caption:'Is Cheque Cleared' ,source:{type:"Data",dataSource:[
      {id:1,value:'YES'},{id:0,value:'NO'}
    ]} , field:{id:'ChequeClearedID',value:'ChequeCleared'}, filter:{},
    // select:{source:{type:'Function',dataSource:{function:invoiceService.getMultiDropDownSource , params :[{type:'Value',source:'Stock'},{type:'Value',source:'0'},{type:'Value',source:'01-JUN-24'},{type:'Value',source:moment().format('DD-MMM-YY')},{type:'Column',source:'BrandID'}] , dropDownKey:'ProductID'}}},
  },template:(e)=>{
    console.log(e)
    let value = e.IsChequeCleared == true ? 'YES' : 'NO'
    return(
      value  
    )
  }
  }]},
 
  { field:"TenantContractFSPaymentDetailID",headerText:'TenantContractFSPaymentDetailID',width:'180px',textAlign:'left' ,headerTextAlign:'center',other:[{visible:false}]},

]


const paymentDetailActionComplete = async (
  grid,
    args,
    setDataSourceState,
    getListService,
    selectedRow,
    selectRowByID,
    startEdit,
    addUserLog,
    editUserLog,
    dataSourceStateLength
)=>{
    
  console.log(selectedRow)
  console.log(args)
  console.log(grid)
  if(args.requestType == 'add' || args.requestType == 'beginEdit'){
    setTimeout(()=>{SaveButton(props.GridID ,'hidden')},1000)
    if(args.requestType == 'add'){
  console.log(args)
  document.getElementById('TenantContractFS_PaymentDetailGridChequeNo').value = '-'
  document.getElementById('TenantContractFS_PaymentDetailGridChequeCleared').value = 'NO'

}else{
  document.getElementById('TenantContractFS_PaymentDetailGridChequeCleared').value = args.rowData.IsChequeCleared == true ? 'YES' : 'NO'
}
  } 
  if(args.requestType === 'save' || args.requestType =='cancel'){
    setTimeout(()=>{SaveButton(props.GridID ,'visible')},1000)

  }

  if(args.requestType == 'save'){
    let PaymentDetailData = {}
    setInputProps((prevValues) => {
      console.log(prevValues);
      PaymentDetailData = prevValues
      return {...prevValues
     }});
     console.log(PaymentDetailData)
     let data={
      TenantContractFSID:PaymentDetailData.TenantContractFSID.value,
      CompanyID: PaymentDetailData.CompanyID.value,
      TenantContractFSDate: PaymentDetailData.TenantContractFSDate.value,
      CompanyRepresentedBy:	 PaymentDetailData.CompanyRepresentedBy.value,
      AccountID	: PaymentDetailData.AccountTitle.value.id,
      TenantTradeLicenseNo	: PaymentDetailData.TenantTradeLicenseNo.value,
      TenantRepresentedBy	: PaymentDetailData.TenantRepresentedBy.value,
      TenantPassportEIDNo: PaymentDetailData.TenantPassportEIDNo.value,
      NationalityID: PaymentDetailData.Nationality.value.id,
      TenantEmail: PaymentDetailData.TenantEmail.value,
      TenantCellNo: PaymentDetailData.TenantCellNo.value,
      ContractStartDate: PaymentDetailData.ContractStartDate.value,
      ContractEndDate: PaymentDetailData.ContractEndDate.value,
      RentAmountAED: PaymentDetailData.RentAmountAED.value,
      DiscountAmountAED: PaymentDetailData.DiscountAmountAED.value,
      AccountIDAgent: PaymentDetailData.AccountTitleAgent.value.id,
      AgentCommissionAmount: PaymentDetailData.AgentCommissionAmount.value,
      AgentCommissionPercent: PaymentDetailData.AgentCommissionPercent.value,
      // Attachment1Path: PaymentDetailData.Attachment1Path.value,
      // Attachment2Path: PaymentDetailData.Attachment2Path.value,
      // Attachment3Path: PaymentDetailData.Attachment3Path.value,
      // Attachment4Path: PaymentDetailData.Attachment4Path.value,
      // Attachment5Path: PaymentDetailData.Attachment5Path.value,
      ContractAmountAED: PaymentDetailData.ContractAmountAED.value,
      TotalContractAmountAED: PaymentDetailData.TotalContractAmountAED.value,
      
     
      ModeOfPaymentID:args.data.ModeOfPaymentID,
      ChequeNo:args.data.ChequeNo,
      ChequeDate:	moment(args.data.ChequeDate).format('DD-MMM-YY'),
      ChequeAmount	:args.data.ChequeAmount,
      IsChequeCleared:	args.data.ChequeClearedID ? 1 :0,
      TenantContractFSPaymentDetailID:args.data.TenantContractFSPaymentDetailID,

      params:{
        TenantContractFSID:PaymentDetailData.TenantContractFSID.value,
        IsChequeCleared:2,
        CompanyID:PaymentDetailData.CompanyID.value,
        },
        details:[
          ...PaymentDetailData.ThirdGridDataSource.value
        ]
    }

   if(args.action == 'add'){
     const response = data.TenantContractFSID == undefined ? await tenantContractService.insertPaymentDetailWithMain(data) : await tenantContractService.insertPaymentDetail(data);
             console.log(response.data.Recordsets.recordset)
            updateMainSecionsValue( {
              TenantContractFSID:{value:response.data.TenantContractFSID}
             })
             CallGridDataSources()
            // setDataSourceState(response.data.Recordsets.recordset)
             callThirdGridDataSources(response.data.TenantContractFSID)

             setTimeout(()=>document.getElementById('TenantContractFS_PaymentDetailGrid_add').click(),1800)
             setTimeout(() => {
              if(document.getElementById('TenantContractGrid_dialogEdit_wrapper_dialog')){
              document.getElementById('TenantContractGrid_dialogEdit_wrapper_dialog').scrollTo({
               top: '100px',
               behavior: "smooth"  // Optional: adds smooth scrolling
             });
            }
             // // .scrollTo({
             //   bottom: 15,
             //   behavior: "smooth"  // Optional: adds smooth scrolling
             // });
            }, 2200)
             getAgentCommissionAmount(PaymentDetailData.ThirdGridDataSource.value ,response.data.TenantContractFSID)
   }
   if(args.action == 'edit' ){
    if(data.TenantContractFSPaymentDetailID){
     const response = await tenantContractService.updatePaymentDetail(data);
            CallGridDataSources()
            // setDataSourceState(response.data.Recordsets.recordset)
            setTimeout(() => {
              if(document.getElementById('TenantContractGrid_dialogEdit_wrapper_dialog')){
              document.getElementById('TenantContractGrid_dialogEdit_wrapper_dialog').scrollTo({
               top: '100px',
               behavior: "smooth"  // Optional: adds smooth scrolling
             });
            }
             // // .scrollTo({
             //   bottom: 15,
             //   behavior: "smooth"  // Optional: adds smooth scrolling
             // });
            }, 1500)
            var gridLength =grid.currentViewData.length
            setTimeout(() => {
                
              let  rowsInd = args.rowIndex +1;
  
            if(rowsInd < gridLength){
                
              //(args)
              selectRowByID(rowsInd)
              startEdit() 
  
            }else{
              setTimeout(()=>document.getElementById('TenantContractFS_PaymentDetailGrid_add').click(),100)

              if(props.isAdd){
                // productsDetailGrid.refresh()
              }
            }
             
             }, 1000);
            getAgentCommissionAmount(PaymentDetailData.ThirdGridDataSource.value ,response.data.TenantContractFSID)    
          }
            else{
      CallGridDataSources();
      

    }
   }
    
  }

}

let AdditionalpaymentDetailColumns = [
  { field:"TenantContractFSID",headerText:'ID',width:'90px',textAlign:'left' ,headerTextAlign:'center',other:[{visible:false}]},

  { field:"AccountID",headerText:'Account Title ID' ,width:'140px',textAlign:'left' ,headerTextAlign:'center',other:[{visible:false}]},
  { field:"AccountTitle",headerText:'Account Title',width:'140px',textAlign:'left' ,headerTextAlign:'center',other:[{'editType':'dropdownedit',edit:{
    caption:'Account Title' ,source:{type:"Route",dataSource:'AdditionalPaymentDetailAccountTitle'} , field:{id:'AccountID',value:'AccountTitle'}, filter:{},
    // select:{source:{type:'Function',dataSource:{function:invoiceService.getMultiDropDownSource , params :[{type:'Value',source:'Stock'},{type:'Value',source:'0'},{type:'Value',source:'01-JUN-24'},{type:'Value',source:moment().format('DD-MMM-YY')},{type:'Column',source:'BrandID'}] , dropDownKey:'ProductID'}}},
  }
  }]},
  { field:"AdditionalPaymentPercent",headerText:'Percent',width:'135px',textAlign:'right' ,headerTextAlign:'center',other:[{initialValue:0,edit:{format:'n2'},format:'n2',editType:'numericedit'}]},
  { field:"AdditionalPaymentAmount",headerText:' Amount ',width:'135px',textAlign:'right' ,headerTextAlign:'center',other:[{initialValue:0,format:'n2',edit:{format:'n2'},editType:'numericedit'}]},
  { field:"AdditionalPaymentRemarks",headerText:' Remarks ',width:'135px',textAlign:'left' ,headerTextAlign:'center',other:[{initialValue:'-',editType:'textedit',endEdit:true}]},
  { field:"TenantContractFSAdditionalPaymentDetailID",headerText:'TenantContractFSAdditionalPaymentDetailID',width:'180px',textAlign:'left' ,headerTextAlign:'center',other:[{visible:false}]},

]


const addtionalPaymentDetailActionComplete = async (
  grid,
  args,
  setDataSourceState,
  getListService ,
   selectedRow ,
   selectRowByID,
   startEdit,
   addUserLog,
   editUserLog,
   dataSourceStateLength
)=>{
    
  console.log(selectedRow)
  console.log(args)
  console.log(grid)
  if(args.requestType == 'add' || args.requestType == 'beginEdit'){
    setTimeout(()=>{SaveButton(props.GridID ,'hidden')},1000)
    document.getElementById('TenantContractFS_AdditionalPaymentDetailGridAdditionalPaymentPercent').addEventListener('blur',async(e)=>{
      setTimeout(() => {
        document.getElementById('TenantContractFS_AdditionalPaymentDetailGridAdditionalPaymentAmount') && document.getElementById('TenantContractFS_AdditionalPaymentDetailGridAdditionalPaymentAmount').select()
      }, 700);
    })
    if(document.getElementById('TenantContractFS_AdditionalPaymentDetailGridAdditionalPaymentAmount')){
    document.getElementById('TenantContractFS_AdditionalPaymentDetailGridAdditionalPaymentPercent').addEventListener('keydown',async(e)=>{
      console.log(e.target.value)
      const formattedNumber = parseInt(document.getElementById('TenantContractFS_AdditionalPaymentDetailGridAdditionalPaymentPercent').value.replace(/,/g, ''));
      const Amount = Math.round(document.getElementById('ContractAmountAED_display').value.replace(/,/g, ''));

      console.log(Amount)
      let response = await tenantContractService.getAmountForAddionalPaymentForPercent(Amount,formattedNumber)
      if(response.data){
        console.log(response.data)
        document.getElementById('TenantContractFS_AdditionalPaymentDetailGridAdditionalPaymentAmount').value = parseFloat(response.data.recordset[0].TaxAmount).toFixed(2);
        
      }

    })
  }
  }
  if(args.requestType === 'save' || args.requestType =='cancel'){
    setTimeout(()=>{SaveButton(props.GridID ,'visible')},1000)

  }
  if(args.requestType == 'save'){
    let PaymentDetailData = {}
    setInputProps((prevValues) => {
      console.log(prevValues);
      PaymentDetailData = prevValues
      return {...prevValues
     }});
     console.log(PaymentDetailData)
     let data={
      TenantContractFSID:PaymentDetailData.TenantContractFSID.value,
      CompanyID: PaymentDetailData.CompanyID.value,
      TenantContractFSDate: PaymentDetailData.TenantContractFSDate.value,
      CompanyRepresentedBy:	 PaymentDetailData.CompanyRepresentedBy.value,
      AccountID	: PaymentDetailData.AccountTitle.value.id,
      TenantTradeLicenseNo	: PaymentDetailData.TenantTradeLicenseNo.value,
      TenantRepresentedBy	: PaymentDetailData.TenantRepresentedBy.value,
      TenantPassportEIDNo: PaymentDetailData.TenantPassportEIDNo.value,
      NationalityID: PaymentDetailData.Nationality.value.id,
      TenantEmail: PaymentDetailData.TenantEmail.value,
      TenantCellNo: PaymentDetailData.TenantCellNo.value,
      ContractStartDate: PaymentDetailData.ContractStartDate.value,
      ContractEndDate: PaymentDetailData.ContractEndDate.value,
      RentAmountAED: PaymentDetailData.RentAmountAED.value,
      DiscountAmountAED: PaymentDetailData.DiscountAmountAED.value,
      AccountIDAgent: PaymentDetailData.AccountTitleAgent.value.id,
      AgentCommissionAmount: PaymentDetailData.AgentCommissionAmount.value,
      AgentCommissionPercent: PaymentDetailData.AgentCommissionPercent.value,
      // Attachment1Path: PaymentDetailData.Attachment1Path.value,
      // Attachment2Path: PaymentDetailData.Attachment2Path.value,
      // Attachment3Path: PaymentDetailData.Attachment3Path.value,
      // Attachment4Path: PaymentDetailData.Attachment4Path.value,
      // Attachment5Path: PaymentDetailData.Attachment5Path.value,
      ContractAmountAED: PaymentDetailData.ContractAmountAED.value,
      TotalContractAmountAED: PaymentDetailData.TotalContractAmountAED.value,
      
      AccountID:args.data.AccountID,
      AdditionalPaymentPercent:args.data.AdditionalPaymentPercent,
      AdditionalPaymentAmount:args.data.AdditionalPaymentAmount,
      AdditionalPaymentRemarks:args.data.AdditionalPaymentRemarks,
      TenantContractFSAdditionalPaymentDetailID:args.data.TenantContractFSAdditionalPaymentDetailID,
      
      params:{
        TenantContractFSID:PaymentDetailData.TenantContractFSID.value,
        }
    }
    console.log(PaymentDetailData.ThirdGridDataSource.value)
   if(args.action == 'add'){
     const response = data.TenantContractFSID == undefined ? await tenantContractService.insertAdditionalPaymentDetailSWithMain(
      {
          ...data,
          details:[
            ...PaymentDetailData.ThirdGridDataSource.value,
            // {AccountID:args.data.AccountID,
            // AdditionalPaymentPercent:args.data.AdditionalPaymentPercent,
            // AdditionalPaymentAmount:args.data.AdditionalPaymentAmount
            // }
          ]
      }
      ) : await tenantContractService.insertAdditionalPaymentDetail(data);
             console.log(response.data.Recordsets.recordset)
            //  setInputProps((prevValues) => ({
            //   ...prevValues,
            //   ['TenantContractFSID']: {...prevValues['TenantContractFSID'] ,value : response.data?.TenantContractFSID}
            // }));
            updateMainSecionsValue( {
              TenantContractFSID:{value:response.data.TenantContractFSID}
             })
            // setDataSourceState(response.data.Recordsets.recordset)
            callThirdGridDataSources(response.data.TenantContractFSID)



             setTimeout(()=>document.getElementById('TenantContractFS_AdditionalPaymentDetailGrid_add').click(),1800)
             setTimeout(() => {
              if(document.getElementById('TenantContractGrid_dialogEdit_wrapper_dialog')){
              document.getElementById('TenantContractGrid_dialogEdit_wrapper_dialog').scrollTo({
               top: '100px',
               behavior: "smooth"  // Optional: adds smooth scrolling
             });
            }
             // // .scrollTo({
             //   bottom: 15,
             //   behavior: "smooth"  // Optional: adds smooth scrolling
             // });
            }, 2200)
   }
   if(args.action == 'edit' ){
    console.log(data)
    if(data.TenantContractFSID == undefined){
      let  filterThirdGridData = PaymentDetailData.ThirdGridDataSource.value.filter((e)=>e.AccountID != data.AccountID)
      const response =  await tenantContractService.insertAdditionalPaymentDetailSWithMain(
        {
            ...data,
            details:[
              ...filterThirdGridData,
              {AccountID:data.AccountID,
              AdditionalPaymentPercent:data.AdditionalPaymentPercent,
              AdditionalPaymentAmount:data.AdditionalPaymentAmount,
              AdditionalPaymentRemarks:data.AdditionalPaymentRemarks
              }
            ]
        }
        ) 
        updateMainSecionsValue( {
          TenantContractFSID:{value:response.data.TenantContractFSID}
         })
         
        // setDataSourceState(response.data.Recordsets.recordset)
        callThirdGridDataSources(response.data.TenantContractFSID)
        var gridLength =grid.currentViewData.length
        setTimeout(() => {
            
          let  rowsInd = args.rowIndex +1;

        if(rowsInd < gridLength){
            
          //(args)
          selectRowByID(rowsInd)
          startEdit() 

        }else{
          setTimeout(()=>document.getElementById('TenantContractFS_AdditionalPaymentDetailGrid_add').click(),100)

          if(props.isAdd){
            // productsDetailGrid.refresh()
          }
        }
         
         }, 1000);
        setTimeout(() => {
          if(document.getElementById('TenantContractGrid_dialogEdit_wrapper_dialog')){
          document.getElementById('TenantContractGrid_dialogEdit_wrapper_dialog').scrollTo({
           top: '100px',
           behavior: "smooth"  // Optional: adds smooth scrolling
         });
        }
         // // .scrollTo({
         //   bottom: 15,
         //   behavior: "smooth"  // Optional: adds smooth scrolling
         // });
        }, 2200)

    }else{
    if(data.TenantContractFSAdditionalPaymentDetailID){
     const response = await tenantContractService.updateAddtionalPaymentDetail(data);
             console.log(response)
            //  await setDataSourceState(response.data.Recordsets.recordset)
            // CallGridDataSources()
            // getListService(true)
            callThirdGridDataSources(response.data.TenantContractFSID)
            var gridLength =grid.currentViewData.length
            setTimeout(() => {
                
              let  rowsInd = args.rowIndex +1;
    
            if(rowsInd < gridLength){
                
              //(args)
              selectRowByID(rowsInd)
              startEdit() 
    
            }else{
              setTimeout(()=>document.getElementById('TenantContractFS_AdditionalPaymentDetailGrid_add').click(),100)

              if(props.isAdd){
                // productsDetailGrid.refresh()
              }
            }
             
             }, 1000);
            setTimeout(() => {
              if(document.getElementById('TenantContractGrid_dialogEdit_wrapper_dialog')){
              document.getElementById('TenantContractGrid_dialogEdit_wrapper_dialog').scrollTo({
               top: '100px',
               behavior: "smooth"  // Optional: adds smooth scrolling
             });
            }
             // // .scrollTo({
             //   bottom: 15,
             //   behavior: "smooth"  // Optional: adds smooth scrolling
             // });
            }, 1000)
    }else{
      // getListService(true)
      callThirdGridDataSources(data.TenantContractFSID)
    }
  }
   }
     console.log(data)
   
       console.log(inputProps)
     
  
  }

}
   

// const PropertyDetailGrid = () =>(
  
// )
// const PaetailGrid = () =>(
  
// )

const [activeTab, setActiveTab] = useState(0);

const handleTabChange = (event, newValue) => {
  setTimeout(()=>{SaveButton(props.GridID ,'visible')},400)
  setActiveTab(newValue);
  if(newValue != 2){
  CallGridDataSources()
  }
  if(newValue == 2){
    if(props.isAdd == false){
      callThirdGridDataSources(props.TenantContractFSID)
      
    }else{
      console.log(inputProps.ThirdGridDataSource.value)
      updateMainSecionsValue({ CallThirdGridDataSource : {value :  true} })
      updateMainSecionsValue({ ThirdGridDataSource: {value:inputProps.ThirdGridDataSource.value}})
      setTimeout(() => {
        updateMainSecionsValue({ CallThirdGridDataSource : {value :  false} })
        
      }, 220);
    }
    
  }

  setTimeout(() => {
    if(document.getElementById('TenantContractGrid_dialogEdit_wrapper_dialog')){
    document.getElementById('TenantContractGrid_dialogEdit_wrapper_dialog').scrollTo({
     top: '100px',
     behavior: "smooth"  // Optional: adds smooth scrolling
   });
  }}
   ,300)
};


const onClosing = (e)=>{
CallGridDataSources()
setTimeout(() => {
  if(e ==  'PropertyName'){
    document.getElementById('TenantContractFS_PropertyDetailGrid_add').click()
    
  }else  if(e ==  'ModeOfPayment'){
    document.getElementById('TenantContractFS_PaymentDetailGrid_add').click()
    
  }
}, 300);
}




let btn = { Id:'UploadFiles',Content:'Upload Files',BgColor:'#2c842d' ,Color:'#f4f4f4',
  Input:{
  Route:'UploadFiles' ,
  Title:'Upload Files', 
  Security:'Tenant Contract',
  Width:'1000px',
  Height:'1300px',
  onClosing:async (e)=>{
   
    }

}}

  return (
    <div onKeyDown={(e)=>e.stopPropagation()}>
      {/* <FirstGridComponent/> */}
      <StructuredGenerate   mainProps={props} title={`Tenant Contract ${props.isAdd == true ? `Add` : `Edit`}`} Inputs={inputsList}/>
      {/* <pre>{JSON.stringify(inputProps, null, 2)}</pre> This is to display current state for debugging */}
      
      <div className='row'>
      <div className='col-sm-9' style={{position:'relative'}}>

      <Box sx={{ width: '100%' }}>
      <Tabs value={activeTab} onChange={handleTabChange} aria-label="Property Tabs">
        <Tab label="Property Details" />
        <Tab label="Payment Details" />
        <Tab label="ADDITIONAL PAYMENTS" />
      </Tabs>

      {/* Property Detail Tab */}
      {activeTab === 0 && (
        <Box p={2}>
          <div className='row'>
          <div className='col-sm-8'>
             <DynamicInputGrid
      Id='TenantContractFS_PropertyDetail'
      
      ColumnsList={propertyDetailColumns}
      GridDataSource= {[
        {
      DataSourceType:inputProps.CallGridDataSource.value ? 'Function' : 'REST',
      DataSource:  ()=>  tenantContractService.getPropertyDetailForList(inputProps.TenantContractFSID.value) ,
      // CreateColumns: [{columnName:'TNADate',columnValue:moment().format('')}]
       }]
}
      DefaultSortedColumnName={'TenantContractFSPropertyDetailID' }
    
      ListActionComplete={propertyDetailActionComplete}
      ToolbarClicking={(e)=>{}}
      SelectRowByID={inputProps.SelectRowByID.value}

      //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
      AllowTemplate={false}
      ToolbarOption={['Add','Edit','Delete','Update','Cancel']}
      AllowGrouping={false}
      AllowExcelExport={false} 
      AllowPdfExport={false} 
      ShowColumnChooser={false}
      AllowPaging={false}
      AllowFiltering={false}
      AllowDataBound={false}
      // ListSecurity={}
      AddSecurity={true}
      EditSecurity={true}
      DeleteSecurity={true}
      DefaultSortedColumnSort={'Ascending'}
      FilterColumns={[]} /* IT USED WHEN GIVING FILTER IN GRID LIKE IsDeleted Column or more */
      GroupColumns={[]} 
      ListDelete={[]}
      DeleteType={'hard'} 
      GridEditSettingMode={'Normal'}
      GridEditSettingHeaderTemplate={'<p></p>'}
      // GridSumColumns={[]}
      // AllowGridSum={true}
      // footerSumCaption={[{
      //   ColumnName:'TransferQty - sum',
      //   Caption:'Qty'
      // }]}
          {...props}
          ></DynamicInputGrid>
            <AddNewDialog 
        Route={'FullProperty'} 
        Security={'Full Property'} 
        onClosed={onClosing} 
        RefName={'PropertyName'}
        Caption={'ADD NEW FULL PROPERTY'}
        />
          </div>
          </div>
        </Box>
      )}

      {/* Other Information Tab */}
      {activeTab === 1 && (
        <Box p={2}>
          <div className='row'>
          <div className='col-sm-12'>
          <DynamicInputGrid
  Id='TenantContractFS_PaymentDetail'
  
  ColumnsList={paymentDetailColumns}
  GridDataSource= {[
    {
  DataSourceType:inputProps.CallGridDataSource.value ? 'Function' : 'REST',
  DataSource:  ()=>  tenantContractService.getPaymentDetailForList(inputProps.TenantContractFSID.value) ,
  // CreateColumns: [{columnName:'TNADate',columnValue:moment().format('')}]
   }]
}
  DefaultSortedColumnName={'TenantContractFSPaymentDetailID' }

  ListActionComplete={paymentDetailActionComplete}
  ToolbarClicking={(e)=>{}}
  SelectRowByID={inputProps.SelectRowByID.value}

  //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
  AllowTemplate={false}
  ToolbarOption={['Add','Edit','Delete','Update','Cancel']}
  AllowGrouping={false}
  AllowExcelExport={false} 
  AllowPdfExport={false} 
  ShowColumnChooser={false}
  AllowPaging={false}
  AllowDataBound={false}
  AllowFiltering={false}

  // ListSecurity={}
  AddSecurity={true}
  EditSecurity={true}
  DeleteSecurity={true}
  DefaultSortedColumnSort={'Ascending'}
  FilterColumns={[]} /* IT USED WHEN GIVING FILTER IN GRID LIKE IsDeleted Column or more */
  GroupColumns={[]} 
  ListDelete={[]}
  DeleteType={'hard'} 
  GridEditSettingMode={'Normal'}
  GridEditSettingHeaderTemplate={'<p></p>'}
  GridSumColumns={[`ChequeAmount`]}
  AllowGridSum={true}
  // footerSumCaption={[{
  //   ColumnName:'TransferQty - sum',
  //   Caption:'Qty'
  // }]}
      {...props}
      ></DynamicInputGrid>
         <AddNewDialog 
        Route={'ModeOfPayment'} 
        Security={'Mode Of Payment'} 
        onClosed={onClosing} 
        RefName={'ModeOfPayment'}
        Caption={'ADD NEW MODE OF PAYMENT'}
        />
      {/* </div>
      </div> */}
      </div>
      </div>
        </Box>
      )}

      {/* More Details Tab */}
      {activeTab === 2 && (
        <Box p={2}>
          <div className='row'>
          <div className='col-sm-12'>
<DynamicInputGrid
              Id='TenantContractFS_AdditionalPaymentDetail'
              
              ColumnsList={AdditionalpaymentDetailColumns}
              GridDataSource= {[
                {
              DataSourceType:inputProps.CallThirdGridDataSource.value ? 'Data' : 'REST',
              DataSource: inputProps.ThirdGridDataSource.value,
              // CreateColumns: [{columnName:'TNADate',columnValue:moment().format('')}]
               }]
        }
              DefaultSortedColumnName={'TenantContractFSAdditionalPaymentDetailID' }
            
              ListActionComplete={addtionalPaymentDetailActionComplete}
              ToolbarClicking={(grid , args , selectedRow , getListService,setDataSourceState)=>{
                console.log(args);
                if(args?.name == "DeletedCompleted"){
                  setTimeout(() => {
                    
                    callThirdGridDataSources(inputProps.TenantContractFSID.value)
                  }, 700);

                }
              }}
              SelectRowByID={inputProps.SelectRowByID.value}
      
              //   OPTIONAL PARAMETERS PLEASE DON'T PASS ANY TIME
              AllowTemplate={false}
              ToolbarOption={['Add','Edit','Delete','Update','Cancel']}
              AllowGrouping={false}
              AllowExcelExport={false} 
              AllowPdfExport={false} 
              ShowColumnChooser={false}
              AllowPaging={false}
              AllowDataBound={false}
              AllowFiltering={false}
              // ListSecurity={}
              AddSecurity={true}
              EditSecurity={true}
              DeleteSecurity={inputProps.TenantContractFSID.value ? true : false}
              DefaultSortedColumnSort={'Ascending'}
              FilterColumns={[]} /* IT USED WHEN GIVING FILTER IN GRID LIKE IsDeleted Column or more */
              GroupColumns={[]} 
              ListDelete={[]}
              DeleteType={'hard'} 
              GridEditSettingMode={'Normal'}
              GridEditSettingHeaderTemplate={'<p></p>'}
              GridSumColumns={[`AdditionalPaymentAmount`]}
              AllowGridSum={true}
              footerSumCaption={[{
                ColumnName:'AdditionalPaymentAmount - sum',
                Caption:'Total Amount'
              }]}
                  {...props}
                  ></DynamicInputGrid>  
                   {/* <AddNewDialog 
        Route={'AdditionalPayment'} 
        Security={'Additional Payment'} 
        onClosed={onClosing} 
        RefName={'AdditionalPayment'}
        Caption={'ADD NEW Additional Payment'}
        />    */}
           <AddNewDialog 
                Route={'ChartOfAccount'} 
                Security={'Chart Of Account'} 
                onClosed={onClosing} 
                RefName={'ChartOfAccount'}
                Caption={'ADD NEW Chart Of Account'}
                />   
                  
                  </div></div>   </Box>
      )}
    </Box>
    {props.isAdd == false &&(
          <div className='col-sm-3 upload-files-dialog-input'>
          <ListButtonPopupList
            key={1} // Use a unique key for each button
            Id={btn.Id}
            Route={btn?.Input?.Route}
            // Enabled={inputProps.GetData.enabled}
            Security={btn?.Input?.Security}
            OnClosed={btn?.Input?.onClosing}
            Title={btn?.Content} // Use the dynamic title from the button object
            InputTitle={btn?.Input?.Title} // Use the dynamic input title from the button object
            Width={btn?.Input?.Width} // Use the dynamic input title from the button object
            SelectedRow={{TenantContractFSID:props.TenantContractFSID,CompanyID: securityService.getCompanyIDLoggedInUserId()  }}
            BgColor={btn?.BgColor}
            Color={btn?.Color}
           
            onBlur={(e,dialogType)=>{
              console.log(e)
              console.log(dialogType)
             
            }}
          
        />
            </div>
        )}
</div>



       
        </div>























      {/* <TabComponent 
       enablePersistence={true} id='employeeDetailTab' readOnly={true} disabled={true} 
        delayUpdate='false'>
        <TabItemsDirective>
        <TabItemDirective
            id='property'
          
            header={{ text: 'Property Detail' }}
            content={() => (
              <p>ghf</p>
           )
            }
            /> 
         <TabItemDirective
            header={{ text: 'Property Detail' }}
            // header={'GRIDS'}
            content={()=> <p>h</p>}
            
            />
          <TabItemDirective
            header={{ text: 'Property Detail' }}
            // header={'GRIDS'}
            content={()=><p>HH</p>}
          />
        </TabItemsDirective>
      </TabComponent> */}
<div className='row'>
<div className='col-sm-4'>
<br/>
<br/>
<br/>
<br/>
<br/>

{/* <a href="#bottom" id="scro?llLink" >Go to Bottom</a>            */}
 </div>
            <div className='col-sm-8'>
            
          </div>
            <div className='col-sm-12'>
            
          </div>
            <div className='col-sm-12'>
            
          </div>
            <div className='col-sm-12'>
            
          </div>
            </div>
      </div>
  );
}; 



export default TenantContractAdd;
